<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="100px" class="fb-form">

            <el-form-item label="字典名称" prop="name" :error="formErrorMsg.name" class="fb-form-item">
                <el-input v-model="formData.name"></el-input>
            </el-form-item>


            <el-form-item label="字典标识" prop="flag" :error="formErrorMsg.flag" class="fb-form-item">
                <el-input v-model="formData.flag"></el-input>
            </el-form-item>

            <el-form-item label="字典描述" prop="description" :error="formErrorMsg.description" class="fb-form-item">
                <el-input v-model="formData.description"></el-input>
            </el-form-item>


            <el-form-item label="字典项" :error="formErrorMsg.dictItems">

                <el-table
                        :data="formData.dictItems"
                        border
                        style="width: 100%">
                    <el-table-column
                            label="名称"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.name" placeholder="请输入名称"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="值"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.dictValue" placeholder="请输入值"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="自定义数据">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.data" placeholder="请输入自定义数据"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-link type="danger" :underline="false" @click="formData.dictItems.splice(formData.dictItems.indexOf(scope.row),1)">删除</el-link>

                        </template>
                    </el-table-column>


                </el-table>

                <el-link icon="el-icon-plus" type="primary" :underline="false" @click="formData.dictItems.push({name: '', flag: '', description: '',})">新增</el-link>


            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "DictAdd",
        components: {},
        data() {
            return {
                api: {
                    add: this.$api.dictType.add
                },
                formErrorMsg: {name: '', flag: '', description: '',dictItems:''},
                formData: {
                    name: '',
                    flag: '',
                    description: '',
                    dictItems: [{name: '', dictValue: '', data: '', sortNum: ''}]
                },
                rules: {
                    name: [
                        {required: true, message: '请输入字典名称', trigger: 'blur'},
                    ],
                    flag: [
                        {required: true, message: '请输入字典标识', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.add,this.formData).then((resp) => {

                            if (resp.data.status === 200) {
                                vm.$message({
                                    type: 'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            } else if (resp.data.status === 400) {

                                console.log(vm.$refs[form]);


                                resp.data.data.errorFields.forEach(function (a) {

                                    vm.formErrorMsg[a.name] = '';
                                    vm.$nextTick(() => {
                                        vm.formErrorMsg[a.name] = a.message;
                                    });


                                });

                                if (resp.data.desc) {
                                    vm.$message({
                                        type: "error",
                                        message: resp.data.desc
                                    });
                                }


                            } else {
                                vm.$message({
                                    type: "error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },
        created() {

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>